import React, { forwardRef } from "react";
import Select from "react-select";

const SelectBox = forwardRef(({ label, value, onChange, options, isLoading, placeholder, style, isDisabled = false, errorMessage, height = "50px", isSearchable = true, isClearable = true, isMulti = false }, ref) => {
  return (
    <div className="selectBoxWrapper">
      {label && <label>{label}</label>}
      <Select
        ref={ref}
        value={value}
        onChange={onChange}
        className="selectBoxWrapperHeight"
        options={options}
        isLoading={isLoading}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        isClearable={isClearable}
        isMulti={isMulti}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
          control: (base) => ({
            ...base,
            borderColor: "#3a57e8",
            borderRadius: "5px",
            minHeight: height,
            height: isMulti ? "auto" : height,
            textTransform: "capitalize",
            ...style,
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#e1e4f8",
            borderRadius: "4px",
          }),
          multiValueLabel: (base) => ({
            ...base,
            fontSize: "12px",
            color: "#2f3299",
            fontWeight: "500",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 99999999, // <-- Ensure dropdown stays on top
          }),
          placeholder: (base) => ({
            ...base,
          }),
        }}
      />

      {errorMessage && <p className="error-message text-danger text-start mb-0">{errorMessage?.message || (typeof errorMessage === "string" ? errorMessage : "")}</p>}
    </div>
  );
});

export default SelectBox;
